import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalManagerProspectForecastDocument = gql`
  query SalesPortalManagerProspectForecast(
    $businessOrganizationUUID: uuid!
    $userTimezone: String!
    $employeeIds: [uuid!]!
    $stages: [ChatProspectStage!]!
  ) {
    getSalesPortalManagerProspectForecast(
      business_organization_id: $businessOrganizationUUID
      user_timezone: $userTimezone
      employee_ids: $employeeIds
      stages: $stages
    ) {
      currency_code
      prospect_count
      total_value_in_micros
      window_days
    }
  }
`;
export function useSalesPortalManagerProspectForecastQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalManagerProspectForecastQuery,
    Types.SalesPortalManagerProspectForecastQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalManagerProspectForecastQuery,
    Types.SalesPortalManagerProspectForecastQueryVariables
  >(SalesPortalManagerProspectForecastDocument, options);
}
export function useSalesPortalManagerProspectForecastLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalManagerProspectForecastQuery,
    Types.SalesPortalManagerProspectForecastQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalManagerProspectForecastQuery,
    Types.SalesPortalManagerProspectForecastQueryVariables
  >(SalesPortalManagerProspectForecastDocument, options);
}
export type SalesPortalManagerProspectForecastQueryHookResult = ReturnType<
  typeof useSalesPortalManagerProspectForecastQuery
>;
export type SalesPortalManagerProspectForecastLazyQueryHookResult = ReturnType<
  typeof useSalesPortalManagerProspectForecastLazyQuery
>;
export type SalesPortalManagerProspectForecastQueryResult = Apollo.QueryResult<
  Types.SalesPortalManagerProspectForecastQuery,
  Types.SalesPortalManagerProspectForecastQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalManagerProspectForecastQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalManagerProspectForecastQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalManagerProspectForecastQuery,
    Types.SalesPortalManagerProspectForecastQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalManagerProspectForecastQuery,
    Types.SalesPortalManagerProspectForecastQueryVariables
  >(SalesPortalManagerProspectForecastDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalManagerProspectForecastLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalManagerProspectForecastLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalManagerProspectForecastQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalManagerProspectForecastQuery,
    Types.SalesPortalManagerProspectForecastQueryVariables
  >(SalesPortalManagerProspectForecastDocument, lazyOptions);
}
